import React from 'react';

export default function FAQ4(){
    return(
        <div className="question mt-40">
            <h4 className="h-4 h-bold">
                Business Reports
            </h4>
            <div className="questions">
                <h6 className="h-6 bold-500 text-left">
                    How can I access Reports?
                </h6>
                <p className="paragraph p-adjustment text-left">
                    You can access your Reports by clicking on Reports from the home menu and choose the report you want to view.
                </p>
                <h6 className="h-6 bold-500 text-left">
                    What reports can I view in Invoice Point?
                </h6>
                <p className="paragraph p-adjustment text-left">
                    We have multiple business reports that will show you the outstanding balance, annual and monthly sales, and much more.
                </p>
            </div>
        </div>
    )
}